import axios from 'axios';
import ServerProperties from '../../config/server.js'

export default {
	/*Load User Chat List*/
	ReadUserList: function(params) {
		axios.defaults.headers.common['Authorization'] = "Bearer " + params.data.AuthorizationToken;
		axios.get(ServerProperties.ATM_CLOUD.API + 'User/Online/')
		.then(function (response) {
		 	params.onsuccess(params, response);
		})
		.catch(error => {            
			params.onfailed(error.response)
		});
	},
	ReadUserBot: function(params) {
		axios.defaults.headers.common['Authorization'] = "Bearer " + params.data.AuthorizationToken;
		axios.get(ServerProperties.ATM_CLOUD.API + 'Tenant/Bot/')
		.then(function (response) {
		 	params.onsuccess(params, response);
		})
		.catch(error => {            
			params.onfailed(error.response)
		});
	},
	ReadUserChatSummary: function(params) {
		axios.defaults.headers.common['Authorization'] = "Bearer " + params.data.AuthorizationToken;
		axios.get(ServerProperties.ATM_CLOUD.API + 'Message/Chats/Summary/')
		.then(function (response) {
		 	params.onsuccess(params, response);
		})
		.catch(error => {            
			params.onfailed(error.response)
		});
	},

	/*Load Chat Message*/
	ReadChatMessage: function(params){
		axios.defaults.headers.common['Authorization'] = "Bearer " + params.data.AuthorizationToken;
		axios.get(
			ServerProperties.ATM_CLOUD.API + 'Message/Chat/' + (params.data.UserData.hasOwnProperty('Online') ? params.data.UserData.Username : 'Bot/Notify') + '/' + (params.data.NextUrl === null || params.data.NextUrl === undefined ? '' : '?last_message=' + params.data.NextUrl)
		)
		.then(function (response) {
		 	params.onsuccess(params, response);
		})
		.catch(error => {            
			params.onfailed(error)
		});
	},
	RegisterChatMessage: function(params){
		axios.defaults.headers.common['Authorization'] = "Bearer " + params.data.AuthorizationToken;
        axios.post(
            ServerProperties.ATM_CLOUD.API+'Message/Send/',
            {
                Content  :params.data.Content,
                ToUser :params.data.ToUser,
            }
        )
        .then(function (response) {
            params.onsuccess(params, response)
        })
        .catch(error => {
            console.log(error)
            params.onfailed(error)
        });
	}
}



// WEBPACK FOOTER //
// ./src/App/chat/ChatSidebar/model.js